import Call from '../Call';

const PushapiCountry = {
    get() {
        return Call(`pushapiCountry`);
    },

    save(factor) {
        return Call('pushapiCountry','POST', factor);
    },

    remove(country) {
        return Call(`pushapiCountry/${country}`,'DELETE');
    }
};

export default PushapiCountry;


// WEBPACK FOOTER //
// ./src/services/API/components/PushapiCountry.js